import React from "react";
import { observer, inject } from "mobx-react";
import { action, extendObservable } from "mobx";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import { ButtonGroup, Button } from "react-bootstrap";
import Toggle from "react-toggle";

import { WEEK_DAYS } from "./constants";

@injectIntl
@inject("rootStore")
@observer
export default class NoteAlarm extends React.Component {
  constructor(props) {
    super(props);

    extendObservable(this, {});

    this.canEdit = props.rootStore.authorizationStore.canEditNote(
      this.props.note
    );
  }

  render() {
    const { intl, note } = this.props;
    const t = id => intl.formatMessage({ id: id });

    return (
      <div className="note-alarm-container">
        <ButtonGroup bsSize="small">
          {Object.values(WEEK_DAYS).map(day => {
            const active = note.noteAlarm[day];
            return (
              <Button
                key={day}
                onClick={() => this.toggleStatus(day)}
                disabled={!this.canEdit}
                style={{
                  backgroundColor: active ? "#0fa69a" : "",
                  color: active ? "#FFF" : "",
                  fontWeight: "bold"
                }}
              >
                {t(day)}
              </Button>
            );
          })}
        </ButtonGroup>

        <div style={{ marginTop: "10px" }}>
          <span style={{ verticalAlign: "top", marginRight: "5px" }}>
            {intl.formatMessage({ id: "repeat_weekly" })}
          </span>

          <Toggle
            checked={note.noteAlarm.repeatWeekly}
            onChange={() => this.toggleStatus("repeatWeekly")}
            disabled={!this.canEdit}
          />
        </div>
      </div>
    );
  }

  @action
  toggleStatus = key => {
    const { note } = this.props;

    note.noteAlarm[key] = !note.noteAlarm[key];
    note.updateNoteAlarm();
  };
}

NoteAlarm.propTypes = {
  note: PropTypes.object.isRequired
};
